import { getAppId, getVariableFlatMenu } from './globalVariable';

export const validateAuthority = (func: string | string[], path: string) => {
    //   const flatMEnuFunc = window.flatMenu;
    // const flatMEnuFunc: any = getVariableFlatMenu();
    const flatMEnuFunc:any = JSON.parse(sessionStorage.getItem(`${getAppId()}-authorityRouters-Functions`) || '{}');
    // console.log('🚀 ~ file: validateRole.ts ~ line 7 ~ validateAuthority ~ flatMEnuFunc2', flatMEnuFunc2);

    if (Array.isArray(func)) {
        if (flatMEnuFunc[path] && func.length > 0) {
            const matchList = func.filter(
                item => flatMEnuFunc[path].findIndex((name: string) => name === item) > -1,
            );
            return matchList.length > 0;
        }
        return false;
    }
    return flatMEnuFunc[path]
        ? flatMEnuFunc[path].findIndex((name: string) => name === func) > -1
        : false;
};

// 清除已缓存菜单
export const clearCacheMenu = () => {
    sessionStorage.removeItem(`${getAppId()}-authorityRouters`);
};
